<template>
  <DefaultTemplate format="center">
    <Signin/>
  </DefaultTemplate>
</template>

<script>
import DefaultTemplate from '@/template/DefaultTemplate'
import Signin from '@/components/Signin'

export default {

  data () {
    return {
     
    }
  },
  components:{
      DefaultTemplate,
      Signin,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Signin.vue